var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneFull24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 24 0 L 24 24 L 0 24 Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.75 3 C 6.92 3 3 6.92 3 11.75 C 3 16.58 6.92 20.5 11.75 20.5 C 16.58 20.5 20.5 16.58 20.5 11.75 C 20.5 6.92 16.58 3 11.75 3 Z M 11.93 14.15 L 10.47 15.61 L 8.96 14.1 L 6.82 11.96 L 8.28 10.5 L 10.42 12.64 L 15.19 7.87 L 16.7 9.38 Z",
    fill: "#77d432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneFull24);
export default __webpack_public_path__ + "static/media/done_full@24.95432ce6729cea5cb23d3acae84e5d02.svg";
export { ForwardRef as ReactComponent };